import React from 'react';
import PageHeaderWrapper from '../../components/PageHeaderWrapper';
import { connect } from 'react-redux';
import { Card, Select, Row, Col, DatePicker, Button } from 'antd';
import Request from '../../request';
import { TableComp } from 'sz-react-utils';
import moment from 'moment';
import rightAuth from "../../components/_utils/userRights";
import styles from './styles.less';
let dateFormat = localStorage.getItem('company-details') ? JSON.parse(localStorage.getItem('company-details')).dateFormat : 'DD.MM.YYYY';
const { Option } = Select;
const { RangePicker, MonthPicker } = DatePicker;

class CollapseViewBox extends React.Component {

    state = {
        cp: true
    }

    render() {
        const { cp } = this.state

        return <React.Fragment>
            <div className={cp ? styles.questioncollapse : styles.questioncollapsenot}>{this.props.children}</div>
            <a style={{ color: 'red', float: 'right' }} onClick={() => {
                this.setState({
                    cp: !cp
                })
            }}>
                {cp ? <p>View More + </p> : <p>View Less - </p>}
            </a>
        </React.Fragment>
    }
}

class CountryWiseStudentReport extends React.Component {
    state = {
        countryId: null,
        countryArr: [],
        allBranches: [],
        time: null,
        count: 0,
        intake: null,
        exportParams: {},
        courseStartDate: [],
        selectedDates: [],
        visaFilters: [{ value: 'Visa Approved', text: 'Visa Approved' }, { value: 'Visa Refused', text: 'Visa Refused' }, { value: 'Visa Waiting', text: 'Visa Waiting' }, { value: 'Refund Waiting', text: 'Refund Waiting' }]
    }


    constructor(props) {
        super(props)
        this.table = React.createRef();
    }


    loadCountries = async () => {
        let response = await Request.getCountries();
        this.setState({ countryArr: response.data });
    }

    loadBranches = async () => {
        let { data } = await Request.loadSimpleBranch();
        data = data.reduce((temp, vv) => {
            temp.push({ value: vv._id, text: vv.branchName });
            return temp;
        }, []);
        this.setState({ allBranches: data });
    }

    componentDidMount() {
        this.loadCountries();
        this.loadBranches();
    }

    apiRequest = (params) => {
        return new Promise(async (resolve) => {
            let { countryId } = this.state;
            let foundCountry = this.state.countryArr.find((val) => val.countryName === countryId);
            countryId = foundCountry._id;
            params.countryId = countryId;
            if (this.state.time) {
                params.time = this.state.time;
            }
            if (this.state.courseStartDate) {
                params.courseStartDate = this.state.courseStartDate;
            }
            let response = await Request.getCountryWiseStudentReport(params);
            this.setState({ count: response.total, exportParams: params });
            return resolve(response);
        })
    }

    onChangeDatePicker = (date) => {
        if (date === null) {
            this.setState({ courseStartDate: [], selectedDates: [] }, () => {
                this.table.current.reload();
            });
            return;
        }
        let { courseStartDate, selectedDates } = this.state;
        let selectedDate = moment(date).format('YYYY-MMM');
        if (selectedDates.includes(selectedDate)) {
            const index = selectedDates.indexOf(selectedDate);
            if (index > -1) {
                selectedDates.splice(index, 1);
                courseStartDate.splice(index, 1);
            }
        } else {
            courseStartDate.push({
                from: moment(date).startOf('month').format('YYYY-MM-DD'),
                to: moment(date).endOf('month').format('YYYY-MM-DD')
            });
            selectedDates.push(moment(date).format('YYYY-MMM'));
        }
        this.setState({
            courseStartDate, selectedDates
        }, () => {
            this.table.current.reload();
        });
    }

    chooseRangerPicker = (date, dateString) => {
        this.setState(
            {
                time: {
                    from: date[0],
                    to: date[1]
                }
            }, () => {
                this.table.current.reload()
                if (date[0] == undefined) {
                    if (this.table && this.table.current) {
                        this.table.current.reload();
                    }
                }
            }
        )
    }

    onOk = value => {
        if (this.table && this.table.current) {
            this.table.current.reload();
        }
    }

    changeMonth = (date, dateString) => {
        this.setState({
            intake: dateString
        }, () => {
            this.table.current.reload();
        })
    }



    render() {
        let { countryArr, allBranches } = this.state;
        let columns = [
            {
                title: 'Sr No.',
                key: 'serialNumber',
                width: 60,
                render: (text, record, index) => (
                    <div>{index + 1}</div>
                )
            },
            {
                title: 'VID',
                key: 'id',
                width: 90,
                searchTextName: 'vid'
            },
            {
                title: 'Student Name',
                key: 'studentName',
                searchTextName: 'Student Name'
            },
            {
                title: 'DOB',
                key: 'dateOfBirth',
                searchTextName: `Date Of Birth ${dateFormat}`,
                render: (text, record) => (
                    <div>{moment(record.dateOfBirth).format(dateFormat)}</div>
                )
            },
            {
                title: 'University',
                key: 'selectedUniversity',
                dataIndex: 'visaDesk.selectedCourse.universityInstitutionName',
                searchTextName: "University Name",
                render: (text, record) => {
                    if (record.atLevel === "Application Desk") {
                        // Ensure record.applicationsDesk and record.applicationsDesk.course exist
                        let courses = (record && record.applicationsDesk && record.applicationsDesk.course)
                            ? record.applicationsDesk.course
                            : [];

                        if (courses.length === 0) {
                            return <div>No Courses Available</div>;
                        }

                        // Generate course list
                        let courseList = courses.map((val, index) => (
                            <div key={index}>
                                {index + 1} {val.universityInstitutionName}
                                <hr />
                            </div>
                        ));

                        // Combine text to check length
                        let combinedText = "";
                        for (let i = 0; i < courses.length; i++) {
                            combinedText += courses[i].universityInstitutionName;
                            if (i !== courses.length - 1) {
                                combinedText += ", ";
                            }
                        }

                        // Use CollapseViewBox if text is too long
                        if (combinedText.length > 100) {
                            return <CollapseViewBox>{courseList}</CollapseViewBox>;
                        } else {
                            return <div>{courseList}</div>;
                        }
                    } else {
                        return <div>{record && record.visaDesk && record.visaDesk.selectedCourse && record.visaDesk.selectedCourse.universityInstitutionName ? record.visaDesk.selectedCourse.universityInstitutionName : "Not Selected"}</div>
                    }
                }
            },
            {
                title: 'Course',
                key: 'selectedCourse',
                dataIndex: 'visaDesk.selectedCourse.courseName',
                searchTextName: "Course Name",
                render: (text, record) => {
                    if (record.atLevel === "Application Desk") {
                        let courses = (record && record.applicationsDesk && record.applicationsDesk.course)
                            ? record.applicationsDesk.course
                            : [];
                        if (courses.length === 0) {
                            return <div>No Courses Available</div>;
                        }
                        let courseList = courses.map((val, index) => (
                            <div key={index}>
                                {index + 1} {val.courseName}
                                <hr />
                            </div>
                        ));

                        let combinedText = "";
                        for (let i = 0; i < courses.length; i++) {
                            combinedText += courses[i].courseName;
                            if (i !== courses.length - 1) {
                                combinedText += ", ";
                            }
                        }
                        if (combinedText.length > 100) {
                            return <CollapseViewBox>{courseList}</CollapseViewBox>;
                        } else {
                            return <div>{courseList}</div>;
                        }
                    } else {
                        return <div>{record && record.visaDesk && record.visaDesk.selectedCourse && record.visaDesk.selectedCourse.courseName ? record.visaDesk.selectedCourse.courseName : "Not Selected"}</div>
                    }
                }
            },
            {
                title: 'Intake',
                key: 'intake',
                render: (text, record) => (
                    <div>{moment(record.visaDesk.courseStartDate).format('MMM-YYYY')}</div>
                )
            },
            {
                title: 'Branch',
                key: 'studentBranchId',
                filters: allBranches,
                dataIndex: 'studentBranchId.branchName'
            },
            {
                title: 'Desk',
                key: 'atLevel',
                filters: [{ text: 'Application Desk', value: 'Application Desk' }, { text: 'Visa Desk', value: 'Visa Desk' }, { text: 'Claim Desk', value: 'Claim Desk' }, { text: 'Archive Desk', value: 'Archive Desk' }],
            },
            {
                title: 'Channel Partner/Direct',
                key: 'channelPartnerName',
                dataIndex: 'visaDesk.selectedCourse.channelPartnerName',
                searchTextName: 'Channel Partner Name',
                render: (text, record) => (
                    <div>{record && record.visaDesk && record.visaDesk.selectedCourse && record.visaDesk.selectedCourse.channelPartnerName ? record && record.visaDesk.selectedCourse.channelPartnerName : "Direct"}</div>
                )
            },
            {
                title: 'Visa Status',
                key: 'status',
                filters: this.state.visaFilters,
                render: (text, record) => (
                    <div>{record && record.visaDesk && record.visaDesk.selectedCourse && record.visaDesk.visaStatus ? record.visaDesk.visaStatus : record && record.visaDesk.fileStatus ? record.visaDesk.fileStatus : "NA"}</div>
                )
            }
        ];
        return (
            <PageHeaderWrapper title={`Country Wise Student Report:- ${this.state.count}`}>
                <Card bordered={true}>
                    <Row gutter={16}>
                        <Col span={5}>
                            <h4>Select Country</h4>
                            <Select
                                placeholder="Select Country"
                                showSearch={true}
                                style={{ width: 200 }}
                                value={this.state.countryId}
                                onChange={(e) => {
                                    this.setState({ countryId: e }, () => {
                                        this.table.current.reload()
                                    })
                                }}
                            >
                                {
                                    countryArr.map((val) => (
                                        <Option key={val._id} value={val.countryName}>{val.countryName}</Option>
                                    ))
                                }
                            </Select>
                        </Col>
                        {this.state.countryId ? <>
                            <Col span={6}>
                                <h4>Filter By Registration Date</h4>
                                <RangePicker
                                    placeholder={['Start Time', 'End Time']}
                                    onChange={this.chooseRangerPicker}
                                    onOk={this.onOk}
                                />
                            </Col>
                            <Col span={6}>
                                <h4>Filter By Intake</h4>
                                <MonthPicker format="YYYY-MMM" onChange={this.onChangeDatePicker} placeholder="Select Intake" />
                                {/* <MonthPicker onChange={this.changeMonth} placeholder="Select month" /> */}
                            </Col>
                            <Col span={4}>
                                <h4>Selected Intakes</h4>
                                <b>{this.state.selectedDates.join(', ')}</b>
                            </Col>
                            <Col span={3} style={{ marginTop: 20 }}>
                                {
                                    rightAuth.checkRights("countryWiseStudentReportExport.view") ?
                                        <Button
                                            style={{}}
                                            onClick={() => this.exportExcel()}>
                                            Export Excel
                                        </Button>
                                        : null
                                }

                            </Col>
                        </> : null}
                    </Row>
                </Card>
                {
                    this.state.countryId ?
                        <Card style={{ marginTop: 10 }} bordered={true}>
                            <TableComp ref={this.table} extraProps={{ scroll: { x: 1450 } }} columns={columns} apiRequest={this.apiRequest} />
                        </Card>
                        : null
                }
            </PageHeaderWrapper>
        )
    }

}


const mapStateToProps = ({ global }) => ({
    categories: global.categories,
    loading: global.buttonLoading
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CountryWiseStudentReport)